// @flow
import {
  fetchListing as apiFetchListing,
  hideListing as apiHideListing,
  unhideListing as apiUnhideListing,
  publishListing as apiPublishListing,
  deleteListing as apiDeleteListing
} from 'api/orgAdmin';
import type { Dispatch, GetState } from '../..';
import { setError } from '../error';
import { clearResults } from '../mainSearch';

type FetchListingRequestAction = {
  type: 'ORG_DASHBOARD_FETCH_LISTING_REQUEST',
  listingId: string
};
type FetchListingSuccessAction = {
  type: 'ORG_DASHBOARD_FETCH_LISTING_SUCCESS',
  listing: Object
};
type ResetListingAction = { type: 'ORG_DASHBOARD_RESET_LISTING' };

export type Action =
  | FetchListingRequestAction
  | FetchListingSuccessAction
  | ResetListingAction;

const fetchListingRequest = (listingId: string): FetchListingRequestAction => ({
  type: 'ORG_DASHBOARD_FETCH_LISTING_REQUEST',
  listingId
});

const fetchListingSuccess = (listing: Object): FetchListingSuccessAction => ({
  type: 'ORG_DASHBOARD_FETCH_LISTING_SUCCESS',
  listing
});

export const fetchListing = ({
  orgId,
  listingType,
  listingId,
  force
}: {
  orgId: string,
  listingType: 'JOB' | 'INTERNSHIP' | 'VOLOP',
  listingId: string,
  force?: boolean
}) => (dispatch: Dispatch, getState: GetState) => {
  const state = getState();
  const listing = state.orgDashboard.listings.byId[listingId];

  if (!listing || force) {
    dispatch(fetchListingRequest(listingId));
    apiFetchListing(orgId, listingType, listingId)
      .then(fetchedListing => {
        dispatch(fetchListingSuccess(fetchedListing));
      })
      .catch(error => {
        dispatch(setError(error));
      });
  }
};

export const updateListing = fetchListingSuccess;

export const hideListing = ({
  orgId,
  listingType,
  listingId
}: {
  orgId: string,
  listingType: 'JOB' | 'INTERNSHIP' | 'VOLOP' | 'IDEALIST_DAY_EVENT',
  listingId: string
}) => (dispatch: Dispatch) =>
  apiHideListing({ orgId, listingType, listingId })
    .then(listing => {
      dispatch(updateListing(listing));
      dispatch(clearResults());
    })
    .catch(setError);

export const unhideListing = ({
  orgId,
  listingType,
  listingId
}: {
  orgId: string,
  listingType: 'JOB' | 'INTERNSHIP' | 'VOLOP' | 'IDEALIST_DAY_EVENT',
  listingId: string
}) => (dispatch: Dispatch) =>
  apiUnhideListing({ orgId, listingType, listingId })
    .then(listing => {
      dispatch(updateListing(listing));
      dispatch(clearResults());
    })
    .catch(setError);

export const publishListing = ({
  orgId,
  listingType,
  listingId
}: {
  orgId: string,
  listingType: 'JOB' | 'INTERNSHIP' | 'VOLOP' | 'IDEALIST_DAY_EVENT',
  listingId: string
}) => (dispatch: Dispatch) =>
  apiPublishListing({ orgId, listingType, listingId })
    .then(listing => {
      dispatch(updateListing(listing));
      dispatch(clearResults());
    })
    .catch(setError);

export const deleteListing = ({
  orgId,
  listingType,
  listingId
}: {
  orgId: string,
  listingType: 'JOB' | 'INTERNSHIP' | 'VOLOP' | 'IDEALIST_DAY_EVENT',
  listingId: string
}) => (dispatch: Dispatch) =>
  apiDeleteListing({ orgId, listingType, listingId })
    .then(deletedListing => {
      dispatch(updateListing(deletedListing));
      dispatch(clearResults());
    })
    .catch(setError);

export const resetListing = () => (dispatch: Dispatch) =>
  dispatch({ type: 'ORG_DASHBOARD_RESET_LISTING' });
